import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { X } from "lucide-react";
import CommonLoader from "./CommonLoader";
import "../styles/CommonDrawer.css";
import { createPortal } from "react-dom";
/* ================= WIDTH MAPPING ================= */
const WIDTH_MAP = {
    sm: "400px",
    md: "610px",
    lg: "700px",
    xl: "900px",
    full: "100%",
};
/* ================= COMPONENT ================= */
const CommonDrawerLayout = ({ open, onClose, title, subtitle, headerActions, children, isLoading = false, width = "lg", customWidth, className = "", showOverlay = true, closeOnOverlayClick = true, }) => {
    if (!open)
        return null;
    const handleOverlayClick = (e) => {
        if (closeOnOverlayClick && e.target.classList.contains("drawer-overlay")) {
            onClose();
        }
    };
    return createPortal(_jsxs(_Fragment, { children: [showOverlay && (_jsx("div", { className: "drawer-overlay", onClick: handleOverlayClick })), _jsxs("div", { className: `common-drawer-sidebar ${className}`, style: { maxWidth: customWidth ?? WIDTH_MAP[width], width: "100%" }, onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "drawer-header", children: [_jsxs("div", { className: "drawer-header-left", children: [_jsx("button", { className: "drawer-close-btn", onClick: onClose, children: _jsx(X, { size: 18, color: "#71717A" }) }), _jsx("div", { className: "line" }), _jsx("div", { className: "drawer-header-text", children: _jsx("div", { className: "drawer-title", children: title }) })] }), headerActions && (_jsx("div", { className: "drawer-header-actions", children: headerActions }))] }), _jsx("div", { className: "drawer-body", children: isLoading ? (_jsx("div", { className: "drawer-loading", children: _jsx(CommonLoader, { className: "table-loader" }) })) : (children) })] })] }), document.body);
};
export default CommonDrawerLayout;
